import initialState from '../../Store/initialState';

import * as types from './actionTypes';

import { locale } from '../Tools/reducers';
import * as systemTypes from '../System/actionTypes';

import download from '../../Utils/download';

let newState;

const stats = (state = initialState.get('stats'), action) => {
  try {
    switch (action.type) {
      // LOCALE
      case systemTypes.FETCH_USER_LANGUAGE:
        newState = state.set('strings', locale(action?.data?.language, 'stats'));
        return newState;

      case types.GET_ADMIN_CONFIG_SUCCESS:
        newState = state.set('config', action.data);
        return newState;

    case types.EXPORT_QUOTATIONS_STATS_SUCCESS:
      let data;
      let ext = action?.params?.format ?? 'txt';
      let mimeType;

      switch (action?.params?.format) {
        case 'json':
          mimeType = `application/${action.params.format}`;
          data = JSON.stringify(action.data, null, 2);
          break;
        case 'csv':
          mimeType = 'application/zip';
          data = action.data;
          ext = 'zip';
          break;
        default:
          mimeType = `text/plain`;
          data = action.data;
          break;
      }

      const fileName = `Export_quotations_${action?.params?.from ?? ''}_${action?.params?.to ?? ''}.${ext}`;

      download(data, fileName, mimeType);

        return state;

      default:
        return state;
    }
  } catch (e) {
    console.log(e.stack);
    return state;
  }
};

export default stats;
